import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_LINK;
const formatPrice = (value) => {
  const num = Number(value);
  if (isNaN(num) || num <= 0) return 'N/A';

  if (num >= 1e7) {
    return `${(num / 1e7).toFixed(2)} Crore`;
  } else if (num >= 1e5) {
    return `${(num / 1e5).toFixed(2)} Lakh`;
  } else {
    return num.toLocaleString('en-IN'); // fallback for values < 1 Lakh
  }
};

const getPriceAndAreaDetails = (flatTypeArray) => {
  let smallest = null;
  let largest = null;

  flatTypeArray.forEach(ft => {
    if (Array.isArray(ft.builtUpAreas)) {
      ft.builtUpAreas.forEach(area => {
        const price = parseFloat(area.expectedPrice || 0);
        if (!isNaN(price) && price > 0) {
          if (!smallest || price < parseFloat(smallest.expectedPrice)) smallest = area;
          if (!largest || price > parseFloat(largest.expectedPrice)) largest = area;
        }
      });
    }
  });

  return { smallest, largest };
};

const Hero = () => {
  const images = [
    'https://100billion.in/client_images/4.png',
    'https://100billion.in/client_images/2.png',
    'https://100billion.in/client_images/3.png',
    'https://100billion.in/client_images/4.png',
    'https://100billion.in/client_images/1.png'
  ];

  const messages = [
    "Search your dream home...",
    "Search in Mumbai ...",
    "Grab your dream with V9 Homes."
  ];

  // Search Bar State
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("Search properties...");
  const [slider,setSlider]=useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  // Search Bar Effect
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setFade(false);
  //     setTimeout(() => {
  //       setIndex((prev) => (prev + 1) % messages.length);
  //       setFade(true);
  //     }, 500);
  //   }, 3000);
  //   return () => clearInterval(interval);
  // }, []);

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        setLoading(true);
        setError(null);
        // const url = `${BASE_URL}/property/getproperty/search`;
        const [res1, res2, res3] = await Promise.all([
          fetch(`${BASE_URL}/resident/getproperty/HBTR0001`),
          fetch(`${BASE_URL}/commercial/getproperty/HBTR0001`),
          fetch(`${BASE_URL}/rentresident/getproperty/HBTR0001`)
        ]);

        const [json1, json2, json3] = await Promise.all([
          res1.json(),
          res2.json(),
          res3.json()
        ]);

        const parseProps = (item) => {
          const parseJSON = (val) => {
            try {
              return typeof val === 'string' ? JSON.parse(val) : val;
            } catch {
              return val;
            }
          };
          return {
            amenities: parseJSON(item.amenities || "[]"),
            carpetArea: parseJSON(item.carpetArea || "[]"),
            flatType: parseJSON(item.flatType || "[]"),
            expectedPrice: parseJSON(item.expectedPrice || "[]"),
            formImages: parseJSON(item.formImages || "[]"),
            locationAdvantage: parseJSON(item.locationAdvantage || item.locationAdvantages || "[]"),
          };
        };

        const combined = [
          ...json1.map(item => ({ ...item, type: "resident", ...parseProps(item) })),
          ...json2.map(item => ({ ...item, type: "commercial", ...parseProps(item) })),
          ...json3.map(item => ({ ...item, type: "rent", ...parseProps(item) }))
        ];

        const uniqueData = combined.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.property_id === value.property_id)
        );

        const sortedData = uniqueData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setProperties(sortedData);
      } catch (err) {
        setError('Failed to fetch properties. Please try again later.');
        console.error('Error fetching properties:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();


  }, []);



  // Filter properties - only show results when user types actual search term
  const getActualSearchTerm = () => {
    if (searchTerm === "Search properties...") return "";
    return searchTerm;
  };

  const filteredProperties = properties.filter((item) => {
    const actualSearch = getActualSearchTerm().toLowerCase();
    if (!actualSearch) return false;
    return `${item.building_name} ${item.city} ${item.address}`
      .toLowerCase()
      .includes(actualSearch);
  });

  console.log(filteredProperties)

  const handlePageChange = (propertyId, propertType) => {
    if (propertType === "Residential") {
      navigate(`/residential-property/${propertyId}`);
    } else if (propertType === "Commercial") {
      navigate(`/commercial-property/${propertyId}`);
    } else if (propertType === "Rent Residential") {
      navigate(`/rent-property/${propertyId}`);
    }
  };




  const fetchDataSlider = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/slider/getslider/HBTR0001`);
      setSlider(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchDataSlider();
  }, [])
  // Background Slider Effect
  useEffect(() => {
    const imagesToUse = slider.length > 0 ? slider : images;
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % imagesToUse.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slider, images]);

  return (
    <div className="hero-container">
      {/* Background Slider - Use API slider or fallback to default images */}
      {(slider.length > 0 ? slider : images).map((img, idx) => (
        <div
          key={idx}
          className={`hero-slide ${idx === currentSlide ? 'active' : ''}`}
          style={{ backgroundImage: `url(${slider.length > 0 ? BASE_URL + '/' + img.image : img})` }}
        />
      ))}

      {/* Overlay Content */}
      <div className="hero-overlay">
        {/* Title and Subtitle */}
        <div className="content-wrapper">
          <h1>Luxury Real Estate Advisory</h1>
          <p>Helping You Buy & Invest in Premium Properties</p>
        </div>

        <div className="search-wrapper">
          <div className="search-container">
            <div className="moving-ring"></div>

            <input
              type="text"
              value={searchTerm}
              placeholder="Search properties..."
              onChange={(e) => setSearchTerm(e.target.value)}
              onFocus={() => {
                if (searchTerm === "Search properties...") {
                  setSearchTerm("");
                }
              }}
              onBlur={() => {
                if (searchTerm === "") {
                  setSearchTerm("Search properties...");
                }
              }}
              className={`search-input ${fade ? "fade-in" : "fade-out"}`}
            />

            <button type="button" className="search-button">
              Search
            </button>
          </div>

          {getActualSearchTerm() && (
            <div className="search-results">
              {loading ? (
                <p className="search-loading">Loading...</p>
              ) : filteredProperties.length === 0 ? (
                <p className="search-empty">No properties found</p>
              ) : (
                filteredProperties.slice(0, 10).map((item) => {
                  const { smallest, largest } = getPriceAndAreaDetails(item.flatType);
                  return <div
                    key={item.property_id}
                    className="search-result-item"
                    onClick={() =>
                      handlePageChange(item.property_id, item.typeofproperty)
                    }
                  >
                    <img
                      src={
                        item.formImages?.length
                          ? `${process.env.REACT_APP_IMAGE_BASE_URL}/Images/Store/${item.formImages[0]}`
                          : "/placeholder-image.jpg"
                      }
                      alt={item.building_name}
                    />

                    <div>
                      <h4>{item.building_name}</h4>
                      <p>{item.city}</p>
                      <span>
                        {smallest?.expectedPrice > 0 && largest?.expectedPrice > 0 ? (
                          smallest.expectedPrice === largest.expectedPrice ? (
                            `₹ ${formatPrice(smallest.expectedPrice)}`
                          ) : (
                            `₹ ${formatPrice(smallest.expectedPrice)} - ₹ ${formatPrice(largest.expectedPrice)}`
                          )
                        ) : smallest?.expectedPrice > 0 ? (
                          `₹ ${formatPrice(smallest.expectedPrice)}`
                        ) : (
                          `₹ ${formatPrice(largest.expectedPrice)}`
                        )}
                      </span>
                    </div>
                  </div>
                })
              )}
            </div>
          )}
        </div>
      </div>


    </div>
  );
}; // <--- THIS WAS MISSING

export default Hero;